import { lazy } from "react";

const ActivityListPage = lazy(() => import("./main"));
const CreateActivityPage = lazy(() => import("./create"));
const UpdateActivityPage = lazy(() => import("./update"));

export { ActivityListPage, CreateActivityPage, UpdateActivityPage };
